import { Box, Button, TextField, Typography, useTheme } from '@mui/material'
import { ModalWrapper } from 'src/components'
import { useStyles } from '../styles'

import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { IItemsRemoveConfirmModalValues } from 'src/types'

interface IProps {
  open: boolean
  handleClose: () => void
  handleConfirmTweet: (tweetId: string) => void
  confirmModalHandler: Dispatch<SetStateAction<IItemsRemoveConfirmModalValues | null>>
}

export const SelectTweetModal = ({
  open,
  handleClose,
  handleConfirmTweet,
  confirmModalHandler,
}: IProps) => {
  const classes = useStyles()
  const theme = useTheme()

  const [tweet, setTweet] = useState<string>('')
  const [error, setError] = useState<string>('')

  useEffect(() => {
    setTweet('')
    setError('')
  }, [open])

  const handleTweetChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value.trim()
    setTweet(val)

    // simple numeric-only check
    if (!val) {
      setError('Tweet ID is required')
    } else if (!/^\d+$/.test(val)) {
      setError('Tweet ID must be digits only')
    } else {
      setError('')
    }
  }

  const handleGetSetupFromTweetConfirm = async () => {
    if (error || !tweet) return

    confirmModalHandler({
      handleConfirm: async () => {
        if (tweet) {
          handleConfirmTweet(tweet)
        }
      },
      customModal: {
        title: 'Confirm Action',
      },
      itemsTitles: [],
      itemsDetails: [{ text: tweet, title: 'Tweet ID' }],
      itemsRelations: [],
      itemsType: '',
    })
  }

  return (
    <ModalWrapper
      open={open}
      onClose={() => {
        setTweet('')
        setError('')
        handleClose()
      }}
      className={classes.reasonModal}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',

          gap: '12px',
        }}
      >
        <Typography
          sx={{
            color: theme.palette.custom.darkBlue2,
            fontSize: '18px',
            fontWeight: 600,
            width: '100%',
          }}
        >
          Enter Tweet Id:
        </Typography>

        <TextField
          label="Tweet ID"
          variant="outlined"
          fullWidth
          value={tweet}
          onChange={handleTweetChange}
          error={!!error}
          helperText={error || 'e.g. 1234567890123456789'}
        />
      </Box>
      <Box sx={{ width: '100%', textAlign: 'center', pt: '10px' }}>
        <Button
          disabled={!!error || !tweet}
          onClick={() => {
            handleGetSetupFromTweetConfirm()
            handleClose()
          }}
          variant="contained"
          size="small"
        >
          Confirm
        </Button>
      </Box>
    </ModalWrapper>
  )
}
